function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isChecked, isIndeterminate } from "./util";
export var keyFilter = function keyFilter(_ref) {
  var source = _ref.source,
      selectedKeys = _ref.selectedKeys,
      pKey = _ref.pKey,
      expandedKeys = _ref.expandedKeys,
      defaultExpandAll = _ref.defaultExpandAll;
  var selected = [];
  var unSelected = [];
  var selectedMap = {};
  var unSelectedMap = {};
  var checkGroup = [];
  var partialSelected = [];
  var partialSelectedMap = {};
  var expandGroup = Array.from(source, function () {
    return defaultExpandAll;
  });
  var expandedCount = 0;
  var restDefaultKeys = [];
  var restExpandedKeys = [];
  var indeterminate = false;
  var indexMap = source.reduce(function (res, item, index) {
    res[item.key] = index;
    return res;
  }, {});
  var temp = Object.assign({}, indexMap);

  if (source.length > 0) {
    var _iterator = _createForOfIteratorHelper(selectedKeys),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _key = _step.value;
        var _index = temp[_key];

        if (_index !== undefined) {
          // isExist
          selectedMap[_key] = _index;
          selected.push(source[_index]);
          temp[_key] = undefined;
        } else {
          restDefaultKeys.push(_key);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var temp2 = Object.assign({}, indexMap);

    if (!defaultExpandAll) {
      var _iterator2 = _createForOfIteratorHelper(expandedKeys),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var index = temp2[key];

          if (index !== undefined) {
            expandGroup[index] = true;
            expandedCount += 1;
          } else {
            restExpandedKeys.push(key);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } else {
    restDefaultKeys.push.apply(restDefaultKeys, _toConsumableArray(selectedKeys));
    restExpandedKeys.push.apply(restExpandedKeys, _toConsumableArray(expandedKeys));
  }

  Object.keys(temp).forEach(function (key) {
    var index = temp[key];

    if (index !== undefined) {
      unSelectedMap[key] = indexMap[key];
      unSelected.push(source[index]);
    }
  });
  var checkStatus = source.reduce(function (res, _ref2) {
    var key = _ref2.key;
    var checked = isChecked(selectedMap[key]);

    if (checked) {
      res.count++;
    }

    res.checkGroup.push(checked ? 'all' : 'none');
    return res;
  }, {
    checkGroup: checkGroup,
    count: 0
  });
  indeterminate = isIndeterminate(selected, unSelected, partialSelected);
  return [_objectSpread({
    pKey: pKey,
    selectedMap: selectedMap,
    selected: selected,
    unSelected: unSelected,
    unSelectedMap: unSelectedMap,
    indexMap: indexMap,
    indeterminate: indeterminate,
    partialSelected: partialSelected,
    partialSelectedMap: partialSelectedMap,
    expandGroup: expandGroup,
    expandedCount: expandedCount
  }, checkStatus), restDefaultKeys, restExpandedKeys];
};